(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core'), require('@angular/common'), require('rxjs'), require('rxjs/operators'), require('@angular/cdk/coercion'), require('@angular/forms'), require('@angular/cdk/platform'), require('@material/ripple'), require('@material/checkbox'), require('@material/data-table')) :
    typeof define === 'function' && define.amd ? define('@shraddhar/mdc-test-web/data-table', ['exports', '@angular/core', '@angular/common', 'rxjs', 'rxjs/operators', '@angular/cdk/coercion', '@angular/forms', '@angular/cdk/platform', '@material/ripple', '@material/checkbox', '@material/data-table'], factory) :
    (global = global || self, factory((global.shraddhar = global.shraddhar || {}, global.shraddhar.mdcTestWeb = global.shraddhar.mdcTestWeb || {}, global.shraddhar.mdcTestWeb.dataTable = {}), global.ng.core, global.ng.common, global.rxjs, global.rxjs.operators, global.ng.cdk.coercion, global.ng.forms, global.ng.cdk.platform, global.mdc.ripple, global.mdc.checkbox, global.mdc.dataTable));
}(this, (function (exports, i0, common, rxjs, operators, coercion, forms, platform, ripple, checkbox, dataTable) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }

    function __param(paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    }

    function __metadata(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __exportStar(m, exports) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }

    function __values(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function __spread() {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    }

    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };

    function __await(v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    }

    function __asyncGenerator(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
        function fulfill(value) { resume("next", value); }
        function reject(value) { resume("throw", value); }
        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
    }

    function __asyncDelegator(o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
    }

    function __asyncValues(o) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
    }

    function __makeTemplateObject(cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    };

    function __importStar(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
        result.default = mod;
        return result;
    }

    function __importDefault(mod) {
        return (mod && mod.__esModule) ? mod : { default: mod };
    }

    function __classPrivateFieldGet(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
    }

    function __classPrivateFieldSet(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
    }

    var MDCComponent = /** @class */ (function () {
        function MDCComponent(elementRef, foundation) {
            var args = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args[_i - 2] = arguments[_i];
            }
            this._elementRef = elementRef;
            this.initialize.apply(this, __spread(args));
            // Note that we initialize foundation here and not within the constructor's default param.
            this._foundation = foundation === undefined ? this.getDefaultFoundation() : foundation;
        }
        /* istanbul ignore next: method param only exists for typing purposes; it does not need to be unit tested */
        MDCComponent.prototype.initialize = function () {
            var _args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                _args[_i] = arguments[_i];
            }
            // Subclasses can override this to do any additional setup work that would be considered part of a
            // "constructor". Essentially, it is a hook into the parent constructor before the foundation is
            // initialized. Any additional arguments besides root and foundation will be passed in here.
        };
        MDCComponent.prototype.getDefaultFoundation = function () {
            // Subclasses must override this method to return a properly configured foundation class for the
            // component.
            throw new Error('Subclasses must override getDefaultFoundation to return a properly configured ' +
                'foundation class');
        };
        MDCComponent.prototype.destroy = function () {
            var _a;
            // Subclasses may implement this method to release any resources / deregister any listeners they have
            // attached. An example of this might be deregistering a resize event from the window object.
            (_a = this._foundation) === null || _a === void 0 ? void 0 : _a.destroy();
        };
        return MDCComponent;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    var MdcFormFieldControl = /** @class */ (function () {
        function MdcFormFieldControl() {
            /** The value of the control. */
            this.value = null;
        }
        return MdcFormFieldControl;
    }());

    var MdcFormField = /** @class */ (function () {
        function MdcFormField(_ngZone, elementRef) {
            this._ngZone = _ngZone;
            this.elementRef = elementRef;
            /** Emits whenever the component is destroyed. */
            this._destroy = new rxjs.Subject();
            this._fluid = false;
            this._alignEnd = false;
            this._nowrap = false;
            this._spaceBetween = false;
        }
        Object.defineProperty(MdcFormField.prototype, "fluid", {
            get: function () {
                return this._fluid;
            },
            set: function (value) {
                this._fluid = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcFormField.prototype, "alignEnd", {
            get: function () {
                return this._alignEnd;
            },
            set: function (value) {
                this._alignEnd = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcFormField.prototype, "nowrap", {
            get: function () {
                return this._nowrap;
            },
            set: function (value) {
                this._nowrap = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcFormField.prototype, "spaceBetween", {
            get: function () {
                return this._spaceBetween;
            },
            set: function (value) {
                this._spaceBetween = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        MdcFormField.prototype.ngAfterContentInit = function () {
            var _a;
            if (this._control) {
                var control = this._control.elementRef.nativeElement;
                if (((_a = control === null || control === void 0 ? void 0 : control.nextElementSibling) === null || _a === void 0 ? void 0 : _a.tagName) === 'LABEL') {
                    this.label = control.nextElementSibling;
                    if (this.label && this._control.inputId) {
                        this.label.setAttribute('for', this._control.inputId);
                        this._loadListeners();
                    }
                }
            }
        };
        MdcFormField.prototype.ngOnDestroy = function () {
            this._destroy.next();
            this._destroy.complete();
        };
        MdcFormField.prototype._loadListeners = function () {
            var _this = this;
            this._ngZone.runOutsideAngular(function () {
                return rxjs.fromEvent(_this.label, 'click').pipe(operators.takeUntil(_this._destroy))
                    .subscribe(function () { return _this._ngZone.run(function () {
                    _this._control.ripple.activateRipple();
                    if (typeof requestAnimationFrame !== 'undefined') {
                        requestAnimationFrame(function () { return _this._control.ripple.deactivateRipple(); });
                    }
                }); });
            });
        };
        MdcFormField.decorators = [
            { type: i0.Component, args: [{
                        selector: 'mdc-form-field',
                        exportAs: 'mdcFormField',
                        host: {
                            '[class.ngx-mdc-form-field--fluid]': 'fluid',
                            '[class.mdc-form-field--align-end]': 'alignEnd',
                            '[class.mdc-form-field--nowrap]': 'nowrap',
                            '[class.mdc-form-field--space-between]': 'spaceBetween',
                        },
                        template: "<ng-content></ng-content>\r\n<ng-content select=\"[mdcHelperText, mdc-helper-text]\"></ng-content>",
                        encapsulation: i0.ViewEncapsulation.None,
                        changeDetection: i0.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        /** @nocollapse */
        MdcFormField.ctorParameters = function () { return [
            { type: i0.NgZone },
            { type: i0.ElementRef }
        ]; };
        MdcFormField.propDecorators = {
            fluid: [{ type: i0.Input }],
            alignEnd: [{ type: i0.Input }],
            nowrap: [{ type: i0.Input }],
            spaceBetween: [{ type: i0.Input }],
            _control: [{ type: i0.ContentChild, args: [MdcFormFieldControl, { static: false },] }]
        };
        return MdcFormField;
    }());

    var FORM_FIELD_DECLARATIONS = [
        MdcFormField,
    ];
    var MdcFormFieldModule = /** @class */ (function () {
        function MdcFormFieldModule() {
        }
        MdcFormFieldModule.decorators = [
            { type: i0.NgModule, args: [{
                        imports: [common.CommonModule],
                        exports: [FORM_FIELD_DECLARATIONS],
                        declarations: [FORM_FIELD_DECLARATIONS]
                    },] }
        ];
        return MdcFormFieldModule;
    }());

    /**
     * Mixin to augment a directive with updateErrorState method.
     * For component with `errorState` and need to update `errorState`.
     */
    function mixinErrorState(base) {
        return /** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var _this = _super.apply(this, __spread(args)) || this;
                /** Whether the component is in an error state. */
                _this.errorState = false;
                _this.required = false;
                return _this;
            }
            class_1.prototype.updateErrorState = function () {
                var oldState = this.errorState;
                var parent = this._parentFormGroup || this._parentForm;
                var matcher = this.errorStateMatcher || this._defaultErrorStateMatcher;
                var control = this.ngControl ? this.ngControl.control : null;
                var newState = matcher.isErrorState(control, parent);
                if (newState !== oldState) {
                    this.errorState = newState;
                }
                // Currently there isn't a great way to determine if Validators.required
                // has been added to the control since form validators are combined into
                // an aggregate function at initialization.
                if (control && !this.required) {
                    this.required = control.hasError('required');
                }
            };
            return class_1;
        }(base));
    }

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /** Provider that defines how form controls behave with regards to displaying error messages. */
    var ErrorStateMatcher = /** @class */ (function () {
        function ErrorStateMatcher() {
        }
        ErrorStateMatcher.prototype.isErrorState = function (control, form) {
            return !!(control && control.invalid && (control.touched || (form && form.submitted)));
        };
        ErrorStateMatcher.decorators = [
            { type: i0.Injectable, args: [{ providedIn: 'root' },] }
        ];
        ErrorStateMatcher.ɵprov = i0.ɵɵdefineInjectable({ factory: function ErrorStateMatcher_Factory() { return new ErrorStateMatcher(); }, token: ErrorStateMatcher, providedIn: "root" });
        return ErrorStateMatcher;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var hasNativeClosest = typeof Element !== 'undefined' && !!Element.prototype.closest;
    /** IE 11 compatible closest implementation that is able to start from non-Element Nodes. */
    function closest(element, selector) {
        if (!(element instanceof Node)) {
            return null;
        }
        var curr = element;
        while (curr != null && !(curr instanceof Element)) {
            curr = curr.parentNode;
        }
        return curr && (hasNativeClosest ?
            curr.closest(selector) : polyfillClosest(curr, selector));
    }
    /** Polyfill for browsers without Element.closest. */
    function polyfillClosest(element, selector) {
        var curr = element;
        while (curr != null && !(curr instanceof Element && matches(curr, selector))) {
            curr = curr.parentNode;
        }
        return (curr || null);
    }
    /** IE 11 compatible matches implementation. */
    function matches(element, selector) {
        return element.matches ?
            element.matches(selector) :
            element['msMatchesSelector'](selector);
    }

    /**
     * Generated bundle index. Do not edit.
     */

    var MdcRipple = /** @class */ (function () {
        function MdcRipple(element, foundation) {
            this.element = element;
            this.initialized = false;
            this._foundation = foundation || new ripple.MDCRippleFoundation(MdcRipple.createAdapter({
                _root: element.nativeElement
            }));
        }
        MdcRipple.createAdapter = function (instance) {
            var adapter = {
                addClass: function (className) { return instance._root.classList.add(className); },
                removeClass: function (className) { return instance._root.classList.remove(className); },
                browserSupportsCssVars: function () { return typeof window !== 'undefined' ? ripple.util.supportsCssVariables(window) : false; },
                isUnbounded: function () { return coercion.coerceBooleanProperty(instance.unbounded); },
                isSurfaceActive: function () { return matches(instance._root, ':active'); },
                isSurfaceDisabled: function () { return coercion.coerceBooleanProperty(instance.disabled); },
                containsEventTarget: function (target) { return instance._root.contains(target); },
                registerDocumentInteractionHandler: function (evtType, handler) {
                    return typeof document === 'object' && !!document ?
                        document.documentElement.addEventListener(evtType, handler, platform.supportsPassiveEventListeners()) : {};
                },
                deregisterDocumentInteractionHandler: function (evtType, handler) {
                    return typeof document === 'object' && !!document ?
                        document.documentElement.removeEventListener(evtType, handler, platform.supportsPassiveEventListeners()) : {};
                },
                registerResizeHandler: function (handler) { return typeof window !== 'undefined' ?
                    window.addEventListener('resize', handler) : {}; },
                deregisterResizeHandler: function (handler) { return typeof window !== 'undefined' ?
                    window.removeEventListener('resize', handler) : {}; },
                updateCssVariable: function (varName, value) {
                    return instance._root.style.setProperty(varName, value);
                },
                computeBoundingRect: function () { return typeof document === 'object' && !!document ?
                    instance._root.getBoundingClientRect() : ({ top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 }); },
                getWindowPageOffset: function () { return typeof window !== 'undefined' ?
                    ({ x: window.pageXOffset, y: window.pageYOffset }) : ({ x: 0, y: 0 }); },
                registerInteractionHandler: function (evtType, handler) {
                    return instance._root.addEventListener(evtType, handler, platform.supportsPassiveEventListeners());
                },
                deregisterInteractionHandler: function (evtType, handler) {
                    return instance._root.removeEventListener(evtType, handler, platform.supportsPassiveEventListeners());
                }
            };
            return adapter;
        };
        MdcRipple.prototype.init = function () {
            if (!this.initialized) {
                this._foundation.init();
                this.initialized = true;
            }
        };
        MdcRipple.prototype.destroy = function () {
            if (this.initialized) {
                this.initialized = false;
                this._foundation.destroy();
            }
        };
        MdcRipple.prototype.layout = function () {
            this._foundation.layout();
        };
        MdcRipple.prototype.ngOnDestroy = function () {
            this.destroy();
        };
        MdcRipple.prototype.activateRipple = function (event) {
            var _this = this;
            setTimeout(function () { return _this._foundation.activate(event); });
        };
        MdcRipple.prototype.deactivateRipple = function () {
            var _this = this;
            setTimeout(function () { return _this._foundation.deactivate(); });
        };
        MdcRipple.prototype.handleBlur = function () {
            this._foundation.handleBlur();
        };
        MdcRipple.decorators = [
            { type: i0.Injectable }
        ];
        /** @nocollapse */
        MdcRipple.ctorParameters = function () { return [
            { type: i0.ElementRef },
            { type: ripple.MDCRippleFoundation, decorators: [{ type: i0.Optional }] }
        ]; };
        return MdcRipple;
    }());

    var MdcRippleDirective = /** @class */ (function () {
        function MdcRippleDirective(_ripple, elementRef) {
            this._ripple = _ripple;
            this.elementRef = elementRef;
            this._primary = false;
            this._secondary = false;
            this._disabled = false;
            this._unbounded = false;
            this._root = this.elementRef.nativeElement;
            this._ripple = this._createRipple();
        }
        Object.defineProperty(MdcRippleDirective.prototype, "attachTo", {
            get: function () {
                return this._attachTo;
            },
            set: function (element) {
                var _a, _b;
                this._attachTo = element;
                (_b = (_a = this._attachTo) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.add('mdc-ripple-surface');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRippleDirective.prototype, "primary", {
            get: function () {
                return this._primary;
            },
            set: function (value) {
                this._primary = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRippleDirective.prototype, "secondary", {
            get: function () {
                return this._secondary;
            },
            set: function (value) {
                this._secondary = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRippleDirective.prototype, "disabled", {
            get: function () {
                return this._disabled;
            },
            set: function (value) {
                this._disabled = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRippleDirective.prototype, "unbounded", {
            get: function () {
                return this._unbounded;
            },
            set: function (value) {
                this._unbounded = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        MdcRippleDirective.prototype.ngOnChanges = function (changes) {
            if (changes['primary'] && this.attachTo) {
                if (this._primary) {
                    this.attachTo.classList.add('mdc-ripple-surface--primary');
                }
                else {
                    this.attachTo.classList.remove('mdc-ripple-surface--primary');
                }
            }
            if (changes['secondary'] && this.attachTo) {
                if (this._secondary) {
                    this.attachTo.classList.add('mdc-ripple-surface--accent');
                }
                else {
                    this.attachTo.classList.remove('mdc-ripple-surface--accent');
                }
            }
        };
        MdcRippleDirective.prototype.ngAfterViewInit = function () {
            this._ripple.init();
        };
        MdcRippleDirective.prototype.ngOnDestroy = function () {
            this._ripple.destroy();
        };
        MdcRippleDirective.prototype._createRipple = function () {
            var _this = this;
            var adapter = __assign(__assign({}, MdcRipple.createAdapter(this)), { addClass: function (className) { var _a, _b; return (_b = (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.add(className); }, computeBoundingRect: function () { var _a, _b; return (_b = (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) !== null && _b !== void 0 ? _b : ({ top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 }); }, isSurfaceActive: function () { return matches(_this.attachTo, ':active'); }, isSurfaceDisabled: function () { return _this._disabled; }, isUnbounded: function () { return _this._unbounded; }, removeClass: function (className) { var _a, _b; return (_b = (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.remove(className); }, updateCssVariable: function (varName, value) { var _a, _b; return (_b = (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.setProperty(varName, value); }, registerInteractionHandler: function (evtType, handler) { var _a; return (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.addEventListener(evtType, handler, platform.supportsPassiveEventListeners()); }, deregisterInteractionHandler: function (evtType, handler) { var _a; return (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.removeEventListener(evtType, handler, platform.supportsPassiveEventListeners()); } });
            return new MdcRipple(this.elementRef, new ripple.MDCRippleFoundation(adapter));
        };
        MdcRippleDirective.decorators = [
            { type: i0.Directive, args: [{
                        selector: '[mdcRipple], mdc-ripple',
                        providers: [MdcRipple],
                    },] }
        ];
        /** @nocollapse */
        MdcRippleDirective.ctorParameters = function () { return [
            { type: MdcRipple },
            { type: i0.ElementRef }
        ]; };
        MdcRippleDirective.propDecorators = {
            attachTo: [{ type: i0.Input }],
            primary: [{ type: i0.Input }],
            secondary: [{ type: i0.Input }],
            disabled: [{ type: i0.Input }],
            unbounded: [{ type: i0.Input }]
        };
        return MdcRippleDirective;
    }());

    var MdcRippleModule = /** @class */ (function () {
        function MdcRippleModule() {
        }
        MdcRippleModule.decorators = [
            { type: i0.NgModule, args: [{
                        exports: [MdcRippleDirective],
                        declarations: [MdcRippleDirective]
                    },] }
        ];
        return MdcRippleModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    var nextUniqueId = 0;
    /** Change event object emitted by MdcCheckbox. */
    var MdcCheckboxChange = /** @class */ (function () {
        function MdcCheckboxChange(
        /** The source MdcCheckbox of the event. */
        source, 
        /** The new `checked` value of the checkbox. */
        checked) {
            this.source = source;
            this.checked = checked;
        }
        return MdcCheckboxChange;
    }());
    var MDC_CHECKBOX_CONTROL_VALUE_ACCESSOR = {
        provide: forms.NG_VALUE_ACCESSOR,
        useExisting: i0.forwardRef(function () { return MdcCheckbox; }),
        multi: true
    };
    var MdcCheckbox = /** @class */ (function (_super) {
        __extends(MdcCheckbox, _super);
        function MdcCheckbox(_platform, _ngZone, _changeDetectorRef, elementRef, ripple, _parentFormField) {
            var _this = _super.call(this, elementRef) || this;
            _this._platform = _platform;
            _this._ngZone = _ngZone;
            _this._changeDetectorRef = _changeDetectorRef;
            _this.elementRef = elementRef;
            _this.ripple = ripple;
            _this._parentFormField = _parentFormField;
            /** Emits whenever the component is destroyed. */
            _this._destroy = new rxjs.Subject();
            _this._initialized = false;
            _this._uniqueId = "mdc-checkbox-" + ++nextUniqueId;
            _this.id = _this._uniqueId;
            _this.name = null;
            _this._checked = false;
            _this._touch = false;
            _this._disabled = false;
            /** The value attribute of the native input element */
            _this.value = null;
            _this._indeterminate = false;
            _this._indeterminateToChecked = true;
            _this._disableRipple = false;
            _this.tabIndex = 0;
            _this.ariaLabel = '';
            _this.ariaLabelledby = null;
            /**
             * Fired when checkbox is checked or unchecked, but not when set
             * indeterminate. Sends the state of [checked].
             */
            _this.change = new i0.EventEmitter();
            /**
             * Fired when checkbox goes in and out of indeterminate state, but not when
             * set to checked. Sends the state of [indeterminate];
             */
            _this.indeterminateChange = new i0.EventEmitter();
            /** View to model callback called when value changes */
            _this._onChange = function () { };
            /** View to model callback called when component has been touched */
            _this._onTouched = function () { };
            _this._root = _this.elementRef.nativeElement;
            if (_this._parentFormField) {
                _parentFormField.elementRef.nativeElement.classList.add('mdc-form-field');
            }
            return _this;
        }
        Object.defineProperty(MdcCheckbox.prototype, "inputId", {
            /** Returns the unique id for the visual hidden input. */
            get: function () {
                return (this.id || this._uniqueId) + "-input";
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcCheckbox.prototype, "checked", {
            get: function () {
                return this._checked;
            },
            set: function (value) {
                if (value !== this.checked) {
                    this._checked = coercion.coerceBooleanProperty(value);
                    this._changeDetectorRef.markForCheck();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcCheckbox.prototype, "touch", {
            get: function () {
                return this._touch;
            },
            set: function (value) {
                this._touch = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcCheckbox.prototype, "disabled", {
            get: function () {
                return this._disabled;
            },
            set: function (value) {
                this.setDisabledState(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcCheckbox.prototype, "indeterminate", {
            /**
             * Alternative state of the checkbox, not user set-able state. Between
             * [checked] and [indeterminate], only one can be true, though both can be
             * false.
             * `true` is INDETERMINATE and `false` is not.
             */
            get: function () {
                return this._indeterminate;
            },
            set: function (value) {
                var _a;
                if (this.disabled) {
                    return;
                }
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._indeterminate) {
                    this._indeterminate = newValue;
                    if (newValue) {
                        this.checked = false;
                    }
                    this.indeterminateChange.emit({ source: this, indeterminate: this._indeterminate });
                    this._changeDetectorRef.markForCheck();
                    (_a = this._foundation) === null || _a === void 0 ? void 0 : _a.handleChange();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcCheckbox.prototype, "indeterminateToChecked", {
            /**
             * Determines the state to go into when [indeterminate] state is toggled.
             * `true` will go to checked and `false` will go to unchecked.
             */
            get: function () {
                return this._indeterminateToChecked;
            },
            set: function (value) {
                this._indeterminateToChecked = coercion.coerceBooleanProperty(value);
                this._changeDetectorRef.markForCheck();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcCheckbox.prototype, "disableRipple", {
            /** Whether the ripple ink is disabled. */
            get: function () {
                return this._disableRipple;
            },
            set: function (value) {
                this._disableRipple = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        MdcCheckbox.prototype.getDefaultFoundation = function () {
            var _this = this;
            // Do not initialize foundation until ngAfterViewInit runs
            if (!this._initialized) {
                return undefined;
            }
            var adapter = {
                addClass: function (className) { return _this._root.classList.add(className); },
                removeClass: function (className) { return _this._root.classList.remove(className); },
                setNativeControlAttr: function (attr, value) {
                    return _this._inputElement.nativeElement.setAttribute(attr, value);
                },
                removeNativeControlAttr: function (attr) { return _this._inputElement.nativeElement.removeAttribute(attr); },
                isIndeterminate: function () { return _this.indeterminate; },
                isChecked: function () { return _this.checked; },
                hasNativeControl: function () { return true; },
                setNativeControlDisabled: function (disabled) { return _this._inputElement.nativeElement.disabled = disabled; },
                forceLayout: function () { return _this._root.offsetWidth; },
                isAttachedToDOM: function () { return true; }
            };
            return new checkbox.MDCCheckboxFoundation(adapter);
        };
        MdcCheckbox.prototype._asyncBuildFoundation = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this._foundation = this.getDefaultFoundation();
                    return [2 /*return*/];
                });
            });
        };
        MdcCheckbox.prototype.ngAfterViewInit = function () {
            var _this = this;
            this._initialized = true;
            this._asyncBuildFoundation()
                .then(function () {
                _this._foundation.init();
                _this.setDisabledState(_this._inputElement.nativeElement.disabled);
                _this.ripple = _this._createRipple();
                _this.ripple.init();
            });
            this._loadListeners();
        };
        MdcCheckbox.prototype.ngOnDestroy = function () {
            this._destroy.next();
            this._destroy.complete();
            this.ripple.destroy();
            this._foundation.destroy();
        };
        MdcCheckbox.prototype.writeValue = function (value) {
            this.checked = !!value;
        };
        MdcCheckbox.prototype.registerOnChange = function (fn) {
            this._onChange = fn;
        };
        MdcCheckbox.prototype.registerOnTouched = function (fn) {
            this._onTouched = fn;
        };
        /** Focuses the checkbox. */
        MdcCheckbox.prototype.focus = function () {
            if (!this.disabled) {
                this._inputElement.nativeElement.focus();
            }
        };
        MdcCheckbox.prototype.toggle = function (checked) {
            this._setState(checked);
        };
        MdcCheckbox.prototype._onInteraction = function (evt) {
            // We have to stop propagation for click events on the visual hidden input element.
            // Preventing bubbling for the second event will solve that issue.
            evt.stopPropagation();
            this._setState();
            this._onChange(this.checked);
            this._changeDetectorRef.markForCheck();
            this.change.emit(new MdcCheckboxChange(this, this.checked));
        };
        MdcCheckbox.prototype._onInputClick = function (evt) {
            evt.stopPropagation();
        };
        MdcCheckbox.prototype.setDisabledState = function (disabled) {
            var _a;
            var newValue = coercion.coerceBooleanProperty(disabled);
            if (newValue !== this._disabled) {
                this._disabled = newValue;
                (_a = this._foundation) === null || _a === void 0 ? void 0 : _a.setDisabled(newValue);
                this._changeDetectorRef.markForCheck();
            }
        };
        MdcCheckbox.prototype._setState = function (checked) {
            var _this = this;
            if (this.disabled) {
                return;
            }
            if (this.indeterminate) {
                this._checked = this.indeterminateToChecked;
                this.indeterminate = false;
            }
            else {
                this.checked = checked || !this.checked;
            }
            // Reset native input when clicked with noop. The native checkbox becomes checked after
            // click, reset it to be align with `checked` value of `mdc-checkbox`.
            this._inputElement.nativeElement.checked = this.checked;
            this._ngZone.runOutsideAngular(function () {
                return requestAnimationFrame(function () { return _this._foundation.handleChange(); });
            });
        };
        MdcCheckbox.prototype._createRipple = function () {
            var _this = this;
            var adapter = __assign(__assign({}, MdcRipple.createAdapter(this)), { isSurfaceActive: function () { return matches(_this._inputElement.nativeElement, ':active'); }, isUnbounded: function () { return true; }, isSurfaceDisabled: function () { return _this.disableRipple; }, deregisterInteractionHandler: function (evtType, handler) {
                    return _this._inputElement.nativeElement.removeEventListener(evtType, handler, platform.supportsPassiveEventListeners());
                }, registerInteractionHandler: function (evtType, handler) {
                    return _this._inputElement.nativeElement.addEventListener(evtType, handler, platform.supportsPassiveEventListeners());
                } });
            return new MdcRipple(this.elementRef, new ripple.MDCRippleFoundation(adapter));
        };
        MdcCheckbox.prototype._loadListeners = function () {
            var _this = this;
            if (!this._platform.isBrowser) {
                return;
            }
            this._ngZone.runOutsideAngular(function () {
                return rxjs.fromEvent(_this._root, 'animationend')
                    .pipe(operators.takeUntil(_this._destroy), operators.filter(function (e) {
                    return e.target === _this._root;
                }))
                    .subscribe(function () {
                    return _this._ngZone.run(function () { return _this._foundation.handleAnimationEnd(); });
                });
            });
        };
        MdcCheckbox.decorators = [
            { type: i0.Component, args: [{
                        selector: 'mdc-checkbox',
                        exportAs: 'mdcCheckbox',
                        host: {
                            '[id]': 'id',
                            'class': 'mdc-checkbox',
                            '[class.mdc-checkbox--touch]': 'touch',
                        },
                        template: "<input type=\"checkbox\"\r\n    #input\r\n    class=\"mdc-checkbox__native-control\"\r\n    [id]=\"inputId\"\r\n    [attr.name]=\"name\"\r\n    [tabIndex]=\"tabIndex\"\r\n    [attr.aria-label]=\"ariaLabel || null\"\r\n    [attr.aria-labelledby]=\"ariaLabelledby\"\r\n    [disabled]=\"disabled\"\r\n    [checked]=\"checked\"\r\n    [attr.value]=\"value\"\r\n    [indeterminate]=\"indeterminate\"\r\n    (change)=\"_onInteraction($event)\"\r\n    (click)=\"_onInputClick($event)\"/>\r\n  <div class=\"mdc-checkbox__background\">\r\n    <svg\r\n      class=\"mdc-checkbox__checkmark\"\r\n      viewBox=\"0 0 24 24\"\r\n      focusable=\"false\">\r\n      <path class=\"mdc-checkbox__checkmark-path\"\r\n        fill=\"none\"\r\n        d=\"M1.73,12.91 8.1,19.28 22.79,4.59\"/>\r\n    </svg>\r\n    <div class=\"mdc-checkbox__mixedmark\"></div>\r\n  </div>\r\n  <div *ngIf=\"!disableRipple && !disabled\" class=\"mdc-checkbox__ripple\"></div>",
                        providers: [
                            MDC_CHECKBOX_CONTROL_VALUE_ACCESSOR,
                            MdcRipple,
                            { provide: MdcFormFieldControl, useExisting: MdcCheckbox }
                        ],
                        encapsulation: i0.ViewEncapsulation.None,
                        changeDetection: i0.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        /** @nocollapse */
        MdcCheckbox.ctorParameters = function () { return [
            { type: platform.Platform },
            { type: i0.NgZone },
            { type: i0.ChangeDetectorRef },
            { type: i0.ElementRef },
            { type: MdcRipple },
            { type: MdcFormField, decorators: [{ type: i0.Optional }] }
        ]; };
        MdcCheckbox.propDecorators = {
            id: [{ type: i0.Input }],
            name: [{ type: i0.Input }],
            checked: [{ type: i0.Input }],
            touch: [{ type: i0.Input }],
            disabled: [{ type: i0.Input }],
            value: [{ type: i0.Input }],
            indeterminate: [{ type: i0.Input }],
            indeterminateToChecked: [{ type: i0.Input }],
            disableRipple: [{ type: i0.Input }],
            tabIndex: [{ type: i0.Input }],
            ariaLabel: [{ type: i0.Input, args: ['aria-label',] }],
            ariaLabelledby: [{ type: i0.Input, args: ['aria-labelledby',] }],
            change: [{ type: i0.Output }],
            indeterminateChange: [{ type: i0.Output }],
            _inputElement: [{ type: i0.ViewChild, args: ['input', { static: true },] }]
        };
        return MdcCheckbox;
    }(MDCComponent));

    var MdcCheckboxModule = /** @class */ (function () {
        function MdcCheckboxModule() {
        }
        MdcCheckboxModule.decorators = [
            { type: i0.NgModule, args: [{
                        imports: [common.CommonModule, MdcFormFieldModule],
                        exports: [
                            MdcFormFieldModule,
                            MdcCheckbox
                        ],
                        declarations: [MdcCheckbox]
                    },] }
        ];
        return MdcCheckboxModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    var uniqueIdCounter = 0;
    var MDCDataTableTable = /** @class */ (function () {
        function MDCDataTableTable(elementRef) {
            this.elementRef = elementRef;
        }
        MDCDataTableTable.decorators = [
            { type: i0.Directive, args: [{
                        selector: '[mdcDataTableTable]',
                        exportAs: 'mdcDataTableTable',
                        host: { 'class': 'mdc-data-table__table' }
                    },] }
        ];
        /** @nocollapse */
        MDCDataTableTable.ctorParameters = function () { return [
            { type: i0.ElementRef }
        ]; };
        return MDCDataTableTable;
    }());
    var MDCDataTableHeaderRow = /** @class */ (function () {
        function MDCDataTableHeaderRow(elementRef) {
            this.elementRef = elementRef;
        }
        MDCDataTableHeaderRow.decorators = [
            { type: i0.Directive, args: [{
                        selector: '[mdcDataTableHeaderRow]',
                        exportAs: 'mdcDataTableHeaderRow',
                        host: { 'class': 'mdc-data-table__header-row' }
                    },] }
        ];
        /** @nocollapse */
        MDCDataTableHeaderRow.ctorParameters = function () { return [
            { type: i0.ElementRef }
        ]; };
        return MDCDataTableHeaderRow;
    }());
    var MDCDataTableHeaderCell = /** @class */ (function () {
        function MDCDataTableHeaderCell(elementRef) {
            this.elementRef = elementRef;
            this._numeric = false;
        }
        Object.defineProperty(MDCDataTableHeaderCell.prototype, "numeric", {
            get: function () {
                return this._numeric;
            },
            set: function (value) {
                this._numeric = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        MDCDataTableHeaderCell.decorators = [
            { type: i0.Component, args: [{
                        selector: '[mdcDataTableHeaderCell]',
                        exportAs: 'mdcDataTableHeaderCell',
                        host: {
                            'role': 'columnheader',
                            'scope': 'col',
                            'class': 'mdc-data-table__header-cell',
                            '[class.mdc-data-table__header-cell--checkbox]': '!!_checkbox',
                            '[class.mdc-data-table__header-cell--numeric]': 'numeric'
                        },
                        template: '<ng-content></ng-content>',
                        encapsulation: i0.ViewEncapsulation.None,
                        changeDetection: i0.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        /** @nocollapse */
        MDCDataTableHeaderCell.ctorParameters = function () { return [
            { type: i0.ElementRef }
        ]; };
        MDCDataTableHeaderCell.propDecorators = {
            numeric: [{ type: i0.Input }],
            _checkbox: [{ type: i0.ContentChild, args: [MdcCheckbox, { static: false },] }]
        };
        return MDCDataTableHeaderCell;
    }());
    var MDCDataTableContent = /** @class */ (function () {
        function MDCDataTableContent(elementRef) {
            this.elementRef = elementRef;
        }
        MDCDataTableContent.decorators = [
            { type: i0.Directive, args: [{
                        selector: '[mdcDataTableContent]',
                        exportAs: 'mdcDataTableContent',
                        host: { 'class': 'mdc-data-table__content' }
                    },] }
        ];
        /** @nocollapse */
        MDCDataTableContent.ctorParameters = function () { return [
            { type: i0.ElementRef }
        ]; };
        return MDCDataTableContent;
    }());
    var MDCDataTableRow = /** @class */ (function () {
        function MDCDataTableRow(elementRef) {
            this.elementRef = elementRef;
            this._id = "mdc-data-table-row-" + uniqueIdCounter++;
            this._selected = false;
        }
        Object.defineProperty(MDCDataTableRow.prototype, "id", {
            /** The unique ID of the row. */
            get: function () {
                return this._id;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MDCDataTableRow.prototype, "selected", {
            get: function () {
                return this._selected;
            },
            set: function (value) {
                this._selected = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        MDCDataTableRow.prototype.getNativeElement = function () {
            return this.elementRef.nativeElement;
        };
        MDCDataTableRow.decorators = [
            { type: i0.Component, args: [{
                        selector: '[mdcDataTableRow]',
                        exportAs: 'mdcDataTableRow',
                        host: {
                            '[attr.data-row-id]': 'id',
                            'class': 'mdc-data-table__row',
                            '[class.mdc-data-table__row-checkbox]': '!!_checkbox',
                            '[class.mdc-data-table__row--selected]': 'selected'
                        },
                        template: '<ng-content></ng-content>',
                        encapsulation: i0.ViewEncapsulation.None,
                        changeDetection: i0.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        /** @nocollapse */
        MDCDataTableRow.ctorParameters = function () { return [
            { type: i0.ElementRef }
        ]; };
        MDCDataTableRow.propDecorators = {
            _checkbox: [{ type: i0.ContentChild, args: [MdcCheckbox, { static: false },] }],
            selected: [{ type: i0.Input }]
        };
        return MDCDataTableRow;
    }());
    var MDCDataTableCell = /** @class */ (function () {
        function MDCDataTableCell(elementRef) {
            this.elementRef = elementRef;
            this._checkbox = false;
            this._numeric = false;
        }
        Object.defineProperty(MDCDataTableCell.prototype, "checkbox", {
            get: function () {
                return this._checkbox;
            },
            set: function (value) {
                this._checkbox = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MDCDataTableCell.prototype, "numeric", {
            get: function () {
                return this._numeric;
            },
            set: function (value) {
                this._numeric = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        MDCDataTableCell.decorators = [
            { type: i0.Component, args: [{
                        selector: '[mdcDataTableCell]',
                        exportAs: 'mdcDataTableCell',
                        host: {
                            'class': 'mdc-data-table__cell',
                            '[class.mdc-data-table__cell--checkbox]': 'checkbox',
                            '[class.mdc-data-table__cell--numeric]': 'numeric'
                        },
                        template: '<ng-content></ng-content>',
                        encapsulation: i0.ViewEncapsulation.None,
                        changeDetection: i0.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        /** @nocollapse */
        MDCDataTableCell.ctorParameters = function () { return [
            { type: i0.ElementRef }
        ]; };
        MDCDataTableCell.propDecorators = {
            checkbox: [{ type: i0.Input }],
            numeric: [{ type: i0.Input }]
        };
        return MDCDataTableCell;
    }());

    var MDCDataTable = /** @class */ (function (_super) {
        __extends(MDCDataTable, _super);
        function MDCDataTable(elementRef) {
            var _this = _super.call(this, elementRef) || this;
            _this.elementRef = elementRef;
            /** Emits whenever the component is destroyed. */
            _this._destroyed = new rxjs.Subject();
            _this._headerCheckboxSubscription = null;
            /** Subscription to checkbox events in rows. */
            _this._rowCheckboxesSubscription = null;
            /** Emitted when all rows are selected. */
            _this.selectedAll = new i0.EventEmitter();
            /** Emitted when all rows are unselected. */
            _this.unselectedAll = new i0.EventEmitter();
            /** Emitted when a row is selected. */
            _this.selectionChanged = new i0.EventEmitter();
            return _this;
        }
        Object.defineProperty(MDCDataTable.prototype, "rowCheckboxChanges", {
            /** Combined stream of all checkbox row change events. */
            get: function () {
                return rxjs.merge.apply(void 0, __spread(this.rows.map(function (row) { return row._checkbox.change; })));
            },
            enumerable: true,
            configurable: true
        });
        MDCDataTable.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                addClass: function (className) { return _this._elementRef.nativeElement.classList.add(className); },
                removeClass: function (className) { return _this._elementRef.nativeElement.classList.remove(className); },
                addClassAtRowIndex: function (rowIndex, className) {
                    return _this.getRows()[rowIndex].getNativeElement().classList.add(className);
                },
                getRowCount: function () { return _this.getRows().length; },
                getRowElements: function () { return [].slice.call(_this.elementRef.nativeElement.querySelectorAll(dataTable.strings.ROW_SELECTOR)); },
                getRowIdAtIndex: function (rowIndex) {
                    return _this.getRows()[rowIndex].getNativeElement().getAttribute(dataTable.strings.DATA_ROW_ID_ATTR);
                },
                getRowIndexByChildElement: function (el) {
                    return _this.getRows().findIndex(function (_) { return _.getNativeElement() === closest(el, dataTable.strings.ROW_SELECTOR); });
                },
                getSelectedRowCount: function () { return _this.elementRef.nativeElement.querySelectorAll(dataTable.strings.ROW_SELECTED_SELECTOR).length; },
                isCheckboxAtRowIndexChecked: function (rowIndex) {
                    return _this.rows.length > 0 && _this.getRows()[rowIndex] && _this.getRows()[rowIndex]._checkbox !== undefined &&
                        _this.getRows()[rowIndex]._checkbox.checked ? true : false;
                },
                isHeaderRowCheckboxChecked: function () { return _this._headerCheckbox ? _this._headerCheckbox.checked : false; },
                isRowsSelectable: function () { return !!_this.elementRef.nativeElement.querySelector(dataTable.strings.ROW_CHECKBOX_SELECTOR); },
                notifyRowSelectionChanged: function (data) {
                    return _this.selectionChanged.emit({
                        index: data.rowIndex,
                        id: data.rowId,
                        selected: data.selected
                    });
                },
                notifySelectedAll: function () { return _this.selectedAll.emit(); },
                notifyUnselectedAll: function () { return _this.unselectedAll.emit(); },
                registerHeaderRowCheckbox: function () { return _this._registerHeaderCheckbox(); },
                registerRowCheckboxes: function () { return _this._registerRowCheckboxes(); },
                removeClassAtRowIndex: function (rowIndex, className) {
                    return _this.getRows()[rowIndex].getNativeElement().classList.remove(className);
                },
                setAttributeAtRowIndex: function (rowIndex, attr, value) {
                    return _this.getRows()[rowIndex].getNativeElement().setAttribute(attr, value);
                },
                setHeaderRowCheckboxChecked: function (checked) { return _this._headerCheckbox.checked = checked; },
                setHeaderRowCheckboxIndeterminate: function (indeterminate) {
                    return _this._headerCheckbox.indeterminate = indeterminate;
                },
                setRowCheckboxCheckedAtIndex: function (rowIndex, checked) {
                    return _this.getRows()[rowIndex]._checkbox ? _this.getRows()[rowIndex]._checkbox.toggle(checked) : null;
                }
            };
            return new dataTable.MDCDataTableFoundation(adapter);
        };
        MDCDataTable.prototype.ngAfterViewInit = function () {
            this._foundation.init();
            this.layoutAsync();
        };
        MDCDataTable.prototype.ngOnDestroy = function () {
            this._destroyed.next();
            this._destroyed.complete();
            this._unsubscribeHeaderCheckbox();
            this._unsubscribeRowCheckboxes();
            if (this._foundation) {
                this._foundation.destroy();
            }
        };
        /**
         * Re-initializes header row checkbox and row checkboxes when selectable rows are added or removed from table.
         * Use this if registering checkbox is asynchronous.
         */
        MDCDataTable.prototype.layoutAsync = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this._foundation.layoutAsync()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * Re-initializes header row checkbox and row checkboxes when selectable rows are added or removed from table.
         * Use this if registering checkbox is synchronous.
         */
        MDCDataTable.prototype.layout = function () {
            this._foundation.layout();
        };
        /**
         * @return Returns array of selected row ids.
         */
        MDCDataTable.prototype.getSelectedRowIds = function () {
            return this._foundation.getSelectedRowIds();
        };
        /**
         * Sets selected row ids. Overwrites previously selected rows.
         * @param rowIds Array of row ids that needs to be selected.
         */
        MDCDataTable.prototype.setSelectedRowIds = function (rowIds) {
            return this._foundation.setSelectedRowIds(rowIds);
        };
        MDCDataTable.prototype.getRows = function () {
            return this.rows.toArray();
        };
        MDCDataTable.prototype.getHeaderCheckbox = function () {
            return this._headerCheckbox;
        };
        MDCDataTable.prototype.showProgress = function () {
            this._foundation.showProgress();
        };
        MDCDataTable.prototype.hideProgress = function () {
            this._foundation.hideProgress();
        };
        MDCDataTable.prototype._unsubscribeHeaderCheckbox = function () {
            if (this._headerCheckboxSubscription) {
                this._headerCheckboxSubscription.unsubscribe();
            }
        };
        MDCDataTable.prototype._unsubscribeRowCheckboxes = function () {
            if (this._rowCheckboxesSubscription) {
                this._rowCheckboxesSubscription.unsubscribe();
            }
        };
        MDCDataTable.prototype._registerHeaderCheckbox = function () {
            var _this = this;
            this._unsubscribeHeaderCheckbox();
            var headerRowCheckboxIndex = this.headerCells.toArray().findIndex(function (_) { return _._checkbox !== undefined; });
            this._headerCheckbox = this.headerCells.toArray()[headerRowCheckboxIndex]._checkbox;
            this._headerCheckboxSubscription = this._headerCheckbox.change.pipe(operators.takeUntil(this._destroyed))
                .subscribe(function (_) { return _this._foundation.handleHeaderRowCheckboxChange(); });
        };
        MDCDataTable.prototype._registerRowCheckboxes = function () {
            var _this = this;
            this._unsubscribeRowCheckboxes();
            this._rowCheckboxesSubscription = this.rowCheckboxChanges.subscribe(function (event) {
                _this._foundation.handleRowCheckboxChange({
                    target: event.source._inputElement.nativeElement
                });
            });
        };
        MDCDataTable.decorators = [
            { type: i0.Component, args: [{
                        selector: 'mdc-data-table',
                        exportAs: 'mdcDataTable',
                        host: { 'class': 'mdc-data-table' },
                        template: '<ng-content></ng-content>',
                        changeDetection: i0.ChangeDetectionStrategy.OnPush,
                        encapsulation: i0.ViewEncapsulation.None
                    }] }
        ];
        /** @nocollapse */
        MDCDataTable.ctorParameters = function () { return [
            { type: i0.ElementRef }
        ]; };
        MDCDataTable.propDecorators = {
            selectedAll: [{ type: i0.Output }],
            unselectedAll: [{ type: i0.Output }],
            selectionChanged: [{ type: i0.Output }],
            rows: [{ type: i0.ContentChildren, args: [MDCDataTableRow, { descendants: true },] }],
            headerCells: [{ type: i0.ContentChildren, args: [MDCDataTableHeaderCell, { descendants: true },] }]
        };
        return MDCDataTable;
    }(MDCComponent));

    var DATA_TABLE_DECLARATIONS = [
        MDCDataTable,
        MDCDataTableCell,
        MDCDataTableContent,
        MDCDataTableHeaderCell,
        MDCDataTableHeaderRow,
        MDCDataTableRow,
        MDCDataTableTable
    ];
    var MDCDataTableModule = /** @class */ (function () {
        function MDCDataTableModule() {
        }
        MDCDataTableModule.decorators = [
            { type: i0.NgModule, args: [{
                        imports: [common.CommonModule],
                        exports: DATA_TABLE_DECLARATIONS,
                        declarations: DATA_TABLE_DECLARATIONS
                    },] }
        ];
        return MDCDataTableModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    exports.MDCDataTable = MDCDataTable;
    exports.MDCDataTableCell = MDCDataTableCell;
    exports.MDCDataTableContent = MDCDataTableContent;
    exports.MDCDataTableHeaderCell = MDCDataTableHeaderCell;
    exports.MDCDataTableHeaderRow = MDCDataTableHeaderRow;
    exports.MDCDataTableModule = MDCDataTableModule;
    exports.MDCDataTableRow = MDCDataTableRow;
    exports.MDCDataTableTable = MDCDataTableTable;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=web-data-table.umd.js.map
